module.exports = __webpack_public_path__ + "static/media/optimizacion.16aa1167.svg";